import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Building2, LogOut, KeyRound } from 'lucide-react';
import { toast } from 'sonner';

const Header = ({ user, setUser }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-4 flex items-center justify-between gap-3 sticky top-0 z-50 shadow-sm" data-testid="header">
      <div className="flex items-center gap-3 min-w-0">
        <img src="/gbt-logo.png" alt="Grey Bull Technologies" className="h-10 sm:h-12 w-auto shrink-0" />
        <span className="text-base sm:text-lg font-bold text-gray-900 truncate">GBT Employee Self Service Portal</span>
      </div>
      <div className="flex items-center gap-3 sm:gap-4 shrink-0">
        {user.profile_photo ? (
          <img 
            src={user.profile_photo} 
            alt={user.name}
            className="w-10 h-10 rounded-full object-cover border-2 border-blue-500"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center text-white font-bold">
            {user.name.charAt(0).toUpperCase()}
          </div>
        )}
        <div className="text-right hidden sm:block" data-testid="user-info">
          <p className="font-semibold text-gray-900" data-testid="user-name">{user.name}</p>
          <p className="text-sm text-gray-600" data-testid="user-employee-id">{user.employee_id}</p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/reset-password')}
          className="text-gray-600 hover:text-indigo-600"
          title="Reset Password"
          data-testid="header-reset-password-button"
        >
          <KeyRound className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleLogout}
          className="text-gray-600 hover:text-red-600"
          data-testid="logout-button"
        >
          <LogOut className="w-4 h-4" />
        </Button>
      </div>
    </header>
  );
};

export default Header;
